<template lang="pug">
  .panel-page
    form.panel.body-1.mx-auto(
      v-if="!emailSent"
      @submit.prevent="submit"
      autocomplete="off"
    )
      FormErrorAlert(
        :message="message"
        :heading="heading"
        v-if="message"
        @dismiss="resetAlert"
      )
      h1 Forgot Username
      p Enter the following information to retrieve your username.

      .form-row.p-2
        .col
          .form-group
            label(for="first-name" required) First Name
            input#first-name.form-control(
              v-model="firstName"
              :class="{'is-invalid': firstNameInvalid}"
            )
            FormError(
              v-show="firstNameInvalid"
              message="First name is required."
            )
        .col
          .form-group
            label(for="last-name" required) Last Name
            input#last-name.form-control(
              v-model="lastName"
              :class="{'is-invalid': lastNameInvalid}"
            )
            FormError(v-show="lastNameInvalid") Last name is required.
      .form-row.p-2
        .col
          .form-group
            label(for="email" required) Email Address
            input#email.form-control(
              v-model="email"
              :class="{'is-invalid': emailInvalid || emailIfInvalid}"
            )
            FormError(v-show="emailInvalid || emailIfInvalid") {{ emailError }}
      .mt-3
        button.btn.btn-primary.mr-3(type="submit") Request Username 
        router-link(to="login") Back to Login Page

    .final-panel.panel.body-1.mx-auto(v-if="emailSent")
      h1 Username Retrieval Email Sent
      p We have sent an email to <strong>{{ email }}</strong> with your username. Please check your inbox to continue.

      div
        router-link.btn.btn-primary(to="login") Back to Login Page

</template>

<script>
import { globalError } from '@/lib/utils'
import {
  mapTouched,
  validationHelpers,
  mapRequired,
  mapRequiredIf,
} from '@/lib/validation'
import axios from '@/lib/axios'
import stdmsg from '@/lib/stdmsg'

export default {
  name: 'ForgotUsername',
  data() {
    return {
      emailError: stdmsg.emailError,
      message: '',
      heading: '',
      emailSent: false,
      firstName: '',
      lastName: '',
      email: '',
      ...mapTouched(['firstName', 'lastName', 'email']),
    }
  },
  computed: {
    ...mapRequired(['firstName', 'lastName', 'email']),
    ...mapRequiredIf(['email'], x => /[^@]+@.+\..+/.test(x)),
  },
  methods: {
    ...validationHelpers(),
    async submit() {
      this.markAllTouched()
      if (
        this.firstNameInvalid ||
        this.lastNameInvalid ||
        this.emailInvalid ||
        this.emailIfInvalid
      ) {
        this.badForm()
        return
      }
      try {
        await axios().post('/api/users/forgot_username', {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email.toLowerCase(),
        })
        this.emailSent = true
        this.resetAlert()
      } catch (err) {
        if (err.response.status === 410) {
          this.noUser()
        } else {
          globalError(err)
        }
      }
    },
    badForm() {
      this.heading = 'Form Errors'
      this.message = stdmsg.formError
    },
    noUser() {
      this.heading = 'No Account Found'
      this.message =
        "We couldn't find an account matching that information. Please try again."
    },
    resetAlert() {
      this.heading = ''
      this.message = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.panel {
  background: white;
}

.final-panel {
  max-height: 200px;
}

.form-row {
  background: #f8f8f8;
}
</style>
